// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Typography,
    MenuItem,
    Autocomplete,
    CircularProgress
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';


import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import DialogDP from '../../../components/acc/DialogDP'
import { useToast } from '../../../components/ToastProvider'

import { getDesigner, getDoctag, getGudang, getProses } from '../../../api/helper';
import appInfo from '../../../configs/app-info';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {

        getData()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        let url = apiUrl.apiUrl + '/sales/laporan/sales-order'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const downloadPdf = () => {
        if (!tglAwal || !tglAkhir) {
            Swal.fire({
                title: 'Pemberitahuan',
                text: 'Tanggal awal dan tanggal akhir wajib diisi.',
                icon: 'warning'
            })

            return
        }

        if (moment(tglAkhir).isBefore(moment(tglAwal))) {
            Swal.fire({
                title: 'Pemberitahuan',
                text: 'Tanggal akhir tidak boleh lebih kecil dari tanggal awal.',
                icon: 'warning'
            })

            return
        }

        const hrstaffId =
            userData?.data.hrstaff_id ??
            userData?.data.hr_staff_id ??
            0

        const params = new URLSearchParams({
            awal: tglAwal,
            akhir: tglAkhir,
            hrstaff_id: String(hrstaffId)
        })

        const url =
            apiUrl.baseUrl +
            `/marketing/laporan-sales/sales-order/pdf?${params.toString()}`

        window.open(url, '_blank', 'noopener,noreferrer')
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='LAPORAN SALES ORDER' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 2,
                                        mt: 1,
                                        flexWrap: {
                                            xs: 'wrap',
                                            md: 'nowrap'
                                        }
                                    }}
                                >
                                    <Button
                                        fullWidth
                                        variant='contained'
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={getData}
                                    >
                                        Cari Data
                                    </Button>

                                    <Button
                                        fullWidth
                                        variant='outlined'
                                        color='error'
                                        startIcon={<Icon icon='mdi:file-pdf-box' />}
                                        onClick={downloadPdf}
                                    >
                                        Download PDF
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                        <MsiDatagrid array={listData}
                            rowStyleRules={[
                                { field: 'is_aktif', operator: '==', value: 0, color: '#ff8787ff' },
                            ]}
                        />
                    </CardContent>
                </div>
            </Grid>

        </Grid>
    )
}
